
// Opciones de Medio (source/medium) para reportes y otras pantallas
export const MEDIUM_OPTIONS = [
  { value: 'administrador', label: 'Administrador' },
  { value: 'app', label: 'App' },
  { value: 'shop', label: 'Shop' },
];

// Meses del año para filtros de cumpleaños
export const MONTHS_OPTIONS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

// Opciones para el filtro de Fecha de (Registro/Suscripción)
export const DATE_TYPE_OPTIONS = [
  { value: 'registro', label: 'Registro' },
  { value: 'suscripcion', label: 'Suscripción' },
];
